import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class CustomTemplateService {
  private _inputs = [
    {value: this.returnRandomValue(), placeholder: 'Molimo unesite podatke', heading: 'Ime kompanije'},
    {value: this.returnRandomValue(), placeholder: 'Molimo unesite podatke', heading: 'Adresa kompanije'},
    {value: this.returnRandomValue(), placeholder: 'Molimo unesite podatke', heading: 'PDV broj'},
    {value: this.returnRandomValue(), placeholder: 'Molimo unesite podatke', heading: 'Broj kompanije'},
    {value: this.returnRandomValue(), placeholder: 'Molimo unesite podatke', heading: 'Datum dospijeca fakture'},
    {value: this.returnRandomValue(), placeholder: 'Molimo unesite podatke', heading: 'Datum'},
    {value: this.returnRandomValue(), placeholder: 'Molimo unesite podatke', heading: 'Opis'},
    {value: this.returnRandomValue(), placeholder: 'Molimo unesite podatke', heading: 'Dokument'},
    {value: this.returnRandomValue(), placeholder: 'Molimo unesite podatke', heading: 'Krajnji rok'},
    {value: this.returnRandomValue(), placeholder: 'Molimo unesite podatke', heading: 'Broj fakture'},
    {value: this.returnRandomValue(), placeholder: 'Molimo unesite podatke', heading: 'Cijena'},
    {value: this.returnRandomValue(), placeholder: 'Molimo unesite podatke', heading: 'Ukupna cijena'},
    {value: this.returnRandomValue(), placeholder: 'Molimo unesite podatke', heading: 'VAT'},
  ]


  get inputs(): any[] {
    return this._inputs;
  }

  set inputs(value: any[]) {
    this._inputs = value;
  }

  returnRandomValue(): string {
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890-";
    let random = this.makeRandom(18, possible);
    if (this.chance()) {
      random = ''
    }

    return random
  }

  makeRandom(lengthOfCode: number, possible: string) {
    let text = "";
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  chance(): any {
    let tempValue = Math.random();
    return tempValue < 0.2
  }
}
